import { useNavigate } from "react-router-dom";
import type { MouseEvent } from "react";

export default function Footer() {
  const basePath = __BASE_PATH__.split('/').filter(Boolean).join('/');
  const pathPrefix = basePath ? `/${basePath}` : '';
  const navigate = useNavigate();

  const handleInternal = (e: MouseEvent<HTMLAnchorElement>, path: string) => {
    e.preventDefault();
    navigate(path);
  };

  return (
    <footer className="border-t border-white/10 py-12 px-6 bg-[#2C3E6B]">
      <div className="max-w-6xl mx-auto flex flex-col gap-8">
        {/* Top Row */}
        <div className="flex flex-col md:flex-row items-center justify-between gap-6">
          <div className="flex items-center gap-3">
            <img
              alt="Healing & Breakthrough Coaching"
              className="w-12 h-12 object-contain hover:scale-[1.06] hover:-translate-y-[3px] transition-all duration-300 ease-out"
              src="https://storage.readdy-site.link/project_files/185c4543-d0dc-49d0-8dbb-59fc7deb7f59/c0cd9c52-4c80-4827-8208-f750b5440eb5_Logo-.png?v=908c6ba8c809d066ed81cd723f530f12"
            />
            <span className="font-heading text-sm font-semibold text-white">
              Healing & Breakthrough Coaching
            </span>
          </div>

          <div className="flex flex-wrap items-center justify-center gap-6">
            <a
              href="https://www.instagram.com/energysafemethod"
              target="_blank"
              rel="noopener noreferrer nofollow"
              className="flex items-center gap-1.5 text-sm text-white/80 hover:text-white transition-colors cursor-pointer whitespace-nowrap"
              aria-label="Instagram — @energysafemethod"
            >
              <span className="w-4 h-4 flex items-center justify-center">
                <i className="ri-instagram-line text-sm" />
              </span>
              @energysafemethod
            </a>
            <a
              href="https://linktr.ee/HealingBreakthroughCoaching"
              target="_blank"
              rel="noopener noreferrer nofollow"
              className="text-sm text-white/80 hover:text-white transition-colors cursor-pointer"
            >
              Linktree
            </a>
            <a
              href="https://buymeacoffee.com/federicaten"
              target="_blank"
              rel="noopener noreferrer nofollow"
              className="text-sm text-white/80 hover:text-white transition-colors cursor-pointer"
            >
              Buy Me a Coffee
            </a>
            <a
              href="mailto:federica.tedeschi3@gmail.com"
              className="text-sm text-white/80 hover:text-white transition-colors cursor-pointer"
            >
              federica.tedeschi3@gmail.com
            </a>
            <a
              href="https://calendly.com/federicatedeschi3/new-meeting"
              target="_blank"
              rel="noopener noreferrer nofollow"
              className="text-sm text-white/80 hover:text-white transition-colors cursor-pointer"
            >
              Book a Call
            </a>
          </div>
        </div>

        {/* Bottom Row */}
        <div className="border-t border-white/10 pt-6 flex flex-col sm:flex-row items-center justify-between gap-4">
          <div className="flex flex-wrap items-center justify-center gap-5">
            <a
              href={`${pathPrefix}/blog`}
              onClick={(e) => handleInternal(e, "/blog")}
              className="text-xs text-white/70 hover:text-white transition-colors cursor-pointer whitespace-nowrap"
            >
              Blog
            </a>
            <a
              href={`${pathPrefix}/privacy-policy`}
              onClick={(e) => handleInternal(e, "/privacy-policy")}
              className="text-xs text-white/70 hover:text-white transition-colors cursor-pointer whitespace-nowrap"
            >
              Privacy Policy
            </a>
            <a
              href={`${pathPrefix}/privacy-statement`}
              onClick={(e) => handleInternal(e, "/privacy-statement")}
              className="text-xs text-white/70 hover:text-white transition-colors cursor-pointer whitespace-nowrap"
            >
              Privacy Statement
            </a>
            <a
              href={`${pathPrefix}/terms-and-conditions`}
              onClick={(e) => handleInternal(e, "/terms-and-conditions")}
              className="text-xs text-white/70 hover:text-white transition-colors cursor-pointer whitespace-nowrap"
            >
              Terms & Conditions
            </a>
            <a
              href={`${pathPrefix}/cookies-policy`}
              onClick={(e) => handleInternal(e, "/cookies-policy")}
              className="text-xs text-white/70 hover:text-white transition-colors cursor-pointer whitespace-nowrap"
            >
              Cookies Policy
            </a>
          </div>
          <p className="text-xs text-white/70 whitespace-nowrap">
            &copy; 2026 Federica Tedeschi. All rights reserved.
          </p>
        </div>

        {/* Disclaimer */}
        <div className="border-t border-white/10 pt-6">
          <p className="text-xs text-white/60 leading-relaxed max-w-3xl mx-auto text-center">
            The information provided on this website is for educational and coaching purposes only and is
            not a substitute for medical advice, diagnosis or treatment. If you have concerns about your
            health, please consult an appropriately qualified healthcare professional.
          </p>
        </div>
      </div>
    </footer>
  );
}